/**
 * ajax底层工具函数封装
 */
import axios from "axios";

import { versionfn } from "../utils/version";
import { displaynotify } from "../utils/displaynote";
import { report } from "@/aips/global";
import i18n from "@/i18n";
import {
  clearStorageAndRedirectToLogin,
  storeAuthData,
} from "@/utils/storageHelper.js";
import {
  isNosugarBrowser,
  getNosugarAccessToken,
  NOSUGAR_CONFIG,
} from "@/utils/nosugar.js";
import { getCanvasContext } from "./canvasContext";
//  import { Message } from 'element-ui';
import { tbMessage } from "@/plugins/tbMessage";
var version = versionfn.version;
let errorType = null;
let errormessage = null;
let nosugarRenewingPromise = null;
let authRequestGeneration = 0;
console.log(process.env.VUE_APP_GC_URL);
console.log(window.location);
let newbaseUrl;
if (window.location.port) {
  newbaseUrl = "http://dev.graphchain.top:1001/generic-canvas";
} else {
  newbaseUrl = "https://dashboard.graphchain.top/generic-canvas";
}
const axiosInstance1 = axios.create({
  baseURL: newbaseUrl,
  timeout: 20000, // 请求超时时间
});
axios.defaults.baseURL = process.env.VUE_APP_GC_URL; // 发送ajax的服务器地址

const request = axios.create({
  baseURL: process.env.VUE_APP_GC_URL,
  // baseURL: "http://192.168.31.130:8081/chain-api",
  timeout: 20000, // 请求超时时间
});
// axios.defaults.baseURL = "http://dev.graphchain.top:1001/chain-api"; // 发送ajax的服务器地址
// axios.defaults.baseURL = "http://192.168.31.130:8081/chain-api"; // 发送ajax的服务器地址
// 发送ajax的服务器地址
// export const weixinfn = {
//   // weixinURL:
//   //   "https://6c22e15b.r2.cpolar.top/wx/bind/wx1f23d9850941884a/qrCode?gcToken=",
//     weixinURL:
//     "http://wechat.graphchain.online/wx/bind/wx2d52763b9e9557a5/qrCode?gcToken=",
// };
// axios.defaults.timeout = 20000; // 请求超时时间，如果请求时间超过10秒，就报错。
// 画布分析接口 URL 匹配：URL 以版本前缀(v2/)开头且紧跟 analysis 系列前缀（config.url 形如 v2/analysis/...，无前导斜杠），
// 包含 manage/vertices 标签接口（标签增删改/批量标签等画布内操作）
// 避免误匹配 v2/data/analysis/ 等非画布请求
const CANVAS_ANALYSIS_URL_RE =
  /^\/?(v\d+\/)(analysis|address\/analysis|manage\/survey\/user\/graph|manage\/lineNote|manage\/swap|manage\/vertices)\//;
// 画布全局刷新接口：URL 无尾路径（manage/canvases/globalrefresh 后无斜杠），单独精确匹配，避免带出 manage/canvases 下其他接口
const CANVAS_REFRESH_URL_RE = /^\/?(v\d+\/)manage\/canvases\/globalrefresh$/;

export function beginAuthAttempt() {
  authRequestGeneration += 1;
}

function retryRequestWithToken(config, token) {
  config._authRefreshRetry = true;
  config.authToken = token;
  return request(config);
}

// 允许携带cookie
request.interceptors.request.use(
  (config) => {
    const storedToken = window.localStorage.getItem("t_k") || "";
    const explicitToken = Object.prototype.hasOwnProperty.call(
      config,
      "authToken",
    )
      ? config.authToken || ""
      : storedToken;
    const token = config.skipAuth ? "" : explicitToken;

    // 记录请求发出时使用的登录态。旧页面的并发请求可能在新登录完成后才返回
    // 401，响应阶段据此避免用旧会话的失败结果清掉刚写入的新 token。
    config._authTokenAtRequest = token;
    config._authGenerationAtRequest = authRequestGeneration;

    //  let token = 'db9a1517-13d5-4e67-9e22-54eef19f00a4'
    // let AccessKey = window.localStorage.getItem('AccessKey')
    config.headers["Cache-Control"] = "no-cache";
    config.headers["Pragma"] = "no-cache";
    config.headers["If-Modified-Since"] = "0"; // 确保每次都获取最新数据
    // 请求头携带token字段（身份证） 【所有的请求 都是基于走这里 都会自动带上】
    if (token) {
      if (typeof config.headers.set === "function") {
        config.headers.set("Authorization", token);
      } else {
        config.headers.authorization = token;
      }
    } else if (typeof config.headers.delete === "function") {
      config.headers.delete("Authorization");
    } else {
      delete config.headers.authorization;
      delete config.headers.Authorization;
    }

    // 根据 localStorage 中的语言设置请求头
    const preferredLanguage =
      localStorage.getItem("preferred-language") || "zh-CN";
    const languageMap = {
      "zh-CN": "zh-CN",
      "zh-TW": "zh-HK",
      en: "en-US",
    };
    config.headers["Accept-Language"] =
      languageMap[preferredLanguage] || "zh-CN";

    // 画布分析请求自动携带当前画布的 canvasId / branchId
    const { canvasId, branchId } = getCanvasContext();
    if (
      canvasId &&
      config.url &&
      (CANVAS_ANALYSIS_URL_RE.test(config.url) ||
        CANVAS_REFRESH_URL_RE.test(config.url))
    ) {
      config.headers["X-Canvas-Id"] = canvasId;
      config.headers["X-Branch-Id"] = branchId || "";
    }

    //  if (AccessKey) {
    //     config.headers.AccessKey  = AccessKey;
    // }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);

// 响应拦截
request.interceptors.response.use(
  (response) => {
    // 判断 如果有code 和 msg 字段
    // let { statu} = response.data;
    // //console.log(response.data.code);
    // //console.log(displaynotify.isShow);

    if (response.data.code) {
      if (displaynotify.isShow) {
        if (response.data.code === 200) {
          // //console.log(11);
          // Message({
          //     type: "success",
          // });
        } else if (response.data.code === 300) {
          if (response.data.message) {
            tbMessage({ type: "warning", text: response.data.message, duration: 2000 });
          }
        }
        // else if (response.data.code === 301) {
        //   Message.warning({ message: response.data.message, duration: 1000 });
        // }
        else if (response.data.code === 500) {
          // 在响应码为 500 时获取请求路径和参数
          const { config } = response;

          const { method, url, params, data } = config;
          // console.log("请求方法:", method);
          // console.log("请求路径:", url);
          // console.log("请求参数:", params || data);

          // 处理网络异常的逻辑
          tbMessage({
            type: "warning",
            text: i18n.t("common.networkError"),
            duration: 2000,
          });
          errorType = "SYSTEM_EXCEPTION";
          errormessage = response.data.message;
          if (url !== "V2/clientReport") {
            reportError(config); // 这里调用函数发送请求报告错误
          }
          // this.$message.error('错了哦，这是一条错误消息');
        }
      }

      return response.data;
    } else {
      return response;
    }
  },
  async (err) => {
    console.log(err);
    const hasResponse = !!(err && err.response);

    // 请求超时错误处理
    if (err.code === "ECONNABORTED" && err.message.indexOf("timeout") !== -1) {
      console.log("请求超时");
      // conditionInfo().then((res) => {
      //   console.log("我是请求超时的接口");
      //   console.log(res);
      // });
      const request = err.config; // 获取请求对象
      const { method, url, params, data } = request; // 获取请求方法、路径、参数等信息
      // console.log("请求方法:", method);
      // console.log("请求路径:", url);
      // console.log("请求参数:", params || data);
      tbMessage({
        type: "error",
        text: i18n.t("common.requestTimeout"),
        duration: 2000,
      });
      errorType = "TIMEOUT";
      errormessage = null;
      // if (url !== "V2/clientReport") {
      //   reportError(request); // 这里调用函数发送请求报告错误
      // }

      // 错误处理  如果错误码是401 就跳清除本地 跳转到登录页面
    } else if (hasResponse && err.response.status == 401) {
      // 获取请求的 URL
      const requestUrl = err.config?.url || "";
      const requestAuthToken = err.config?._authTokenAtRequest || "";
      const currentAuthToken = window.localStorage.getItem("t_k") || "";
      const requestAuthGeneration = err.config?._authGenerationAtRequest;
      const isStaleAuthResponse =
        requestAuthToken !== currentAuthToken ||
        requestAuthGeneration !== authRequestGeneration;
      const isAnonymousRequest = !!err.config?.skipAuth;
      const isLoginRoute =
        typeof window !== "undefined" &&
        window.location.hash.split("?")[0] === "#/login";

      // 对于 checkGoogleAuthCode 和 bindingGoogleAuthCode 接口，不做处理，让组件自己的 catch 处理
      const isGoogleAuthApi =
        requestUrl.includes("checkGoogleAuthCode") ||
        requestUrl.includes("bindingGoogleAuthCode");
      const isNosugarAuthApi =
        requestUrl.includes("/nosugar/auth") ||
        requestUrl.includes("/user/browser/login");
      const isBrowserLoginApi = requestUrl.includes("/user/browser/login");

      if (isAnonymousRequest || (isLoginRoute && !isGoogleAuthApi)) {
        console.log("[认证] 登录流程中的 401 交由调用方处理:", requestUrl);
      } else if (
        !isGoogleAuthApi &&
        !isNosugarAuthApi &&
        !isBrowserLoginApi &&
        isStaleAuthResponse
      ) {
        if (
          currentAuthToken &&
          requestAuthGeneration === authRequestGeneration &&
          !err.config._authRefreshRetry
        ) {
          console.log("[认证] 使用已更新 token 重试旧请求:", requestUrl);
          return retryRequestWithToken(err.config, currentAuthToken);
        }
        console.log("[认证] 忽略旧登录态返回的 401:", requestUrl);
      } else if (!isGoogleAuthApi && !isNosugarAuthApi && !isBrowserLoginApi) {
        if (!err.config._authRefreshRetry) {
          try {
            const { refreshAccessTokenSilently } = await import(
              "@/utils/authTokenManager"
            );
            const renewedToken = await refreshAccessTokenSilently();
            if (
              renewedToken &&
              renewedToken !== requestAuthToken &&
              requestAuthGeneration === authRequestGeneration
            ) {
              console.log("[认证] Token 续期成功，重试原请求:", requestUrl);
              return retryRequestWithToken(err.config, renewedToken);
            }
          } catch (error) {
            console.warn("[认证] Token 静默续期失败:", requestUrl, error);
          }
        }

        // 无糖浏览器内：尝试用 nosugar token 静默续期图链 JWT
        if (
          isNosugarBrowser() &&
          !err.config._nosugarRetry &&
          !err.config._authRefreshRetry
        ) {
          console.log("[无糖]", "401 Token过期，尝试静默续期...");
          console.log("[无糖]", "  失败的请求:", err.config?.url);
          err.config._nosugarRetry = true;
          try {
            if (!nosugarRenewingPromise) {
              nosugarRenewingPromise = (async () => {
                const { browserLogin } = await import("@/aips/login");
                const accessToken = await getNosugarAccessToken(
                  NOSUGAR_CONFIG.APP_ID,
                );
                return browserLogin({
                  access_token: accessToken,
                });
              })().finally(() => {
                nosugarRenewingPromise = null;
              });
            }

            const authRes = await nosugarRenewingPromise;
            if (authRes.code === 200 && authRes.data?.token?.accessToken) {
              const tokenBeforeStore =
                window.localStorage.getItem("t_k") || "";
              if (
                requestAuthGeneration !== authRequestGeneration ||
                tokenBeforeStore !== requestAuthToken
              ) {
                console.log(
                  "[无糖]",
                  "登录态已更新，忽略旧的静默续期结果:",
                  requestUrl,
                );
                if (
                  tokenBeforeStore &&
                  requestAuthGeneration === authRequestGeneration
                ) {
                  return retryRequestWithToken(err.config, tokenBeforeStore);
                }
                return Promise.reject(err);
              }
              console.log("[无糖]", "  ✅ 静默续期成功，重试原请求");
              // 统一存储认证数据（含 roles）
              storeAuthData(authRes.data);
              return retryRequestWithToken(
                err.config,
                authRes.data.token.accessToken,
              );
            } else {
              console.log(
                "[无糖]",
                "  ❌ 静默续期失败，authRes.code:",
                authRes.code,
              );
            }
          } catch (e) {
            console.error("[无糖]", "  ❌ 静默续期异常:", e.message);
            // 静默续期失败，回退到现有逻辑
          }
        }
        // 续期期间登录态也可能已经被其他登录流程替换，清理前再次确认。
        const latestAuthToken = window.localStorage.getItem("t_k") || "";
        if (
          requestAuthToken === latestAuthToken &&
          requestAuthGeneration === authRequestGeneration
        ) {
          beginAuthAttempt();
          clearStorageAndRedirectToLogin();
        } else {
          console.log("[认证] 登录态已更新，忽略旧请求的 401:", requestUrl);
        }
      } else if (isNosugarAuthApi || isBrowserLoginApi) {
        console.log(
          "[无糖]",
          "nosugar 认证接口返回401，不再递归重试:",
          requestUrl,
        );
      }
      // 如果是 Google Auth 相关接口，不做任何处理，直接让错误传递到组件的 catch 块
    } else if (hasResponse && err.response.status == 403) {
      if (displaynotify.isShow) {
        // Message.error({ message: "权限不足" });
      }
    } else if (!hasResponse) {
      tbMessage({
        type: "error",
        text: i18n.t("common.networkError"),
        duration: 2000,
      });
    }
    // else if (err.response.status == 403) {
    //   if (displaynotify.isShow) {
    //     Message.error({ message: "权限不足" });
    //   }
    // }

    return Promise.reject(err);
  },
);

axiosInstance1.interceptors.response.use(
  (response) => {
    console.log("响应拦截器 2：转换响应数据");

    // 假设我们要转换响应数据的格式
    // response.data = { transformed: true, originalData: response.data };
    if (response.data.code) {
      if (response.data.code === 200) {
        // //console.log(11);
        // Message({
        //     type: "success",
        // });
      } else if (response.data.code === 300) {
        tbMessage({ type: "warning", text: response.data.message, duration: 2000 });
      } else if (response.data.code === 500) {
        // 在响应码为 500 时获取请求路径和参数
        const { config } = response;

        const { method, url, params, data } = config;
        // console.log("请求方法:", method);
        // console.log("请求路径:", url);
        // console.log("请求参数:", params || data);

        // 处理网络异常的逻辑
        tbMessage({
          type: "warning",
          text: i18n.t("common.networkError"),
          duration: 2000,
        });
        errorType = "SYSTEM_EXCEPTION";
        errormessage = response.data.message;
        if (url !== "V2/clientReport") {
          reportError(config); // 这里调用函数发送请求报告错误
        }
        // this.$message.error('错了哦，这是一条错误消息');
      }
      return response;
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 发送请求报告错误的函数
function reportError(request) {
  console.log("在这里发送请求向后端报告错误，可以使用axios再次发送请求");
  console.log(request);
  // 在这里发送请求向后端报告错误，可以使用axios再次发送请求
  request
    .post(`${version}/clientReport`, {
      exceptionType: errorType,
      path: request.url,
      parameter: request.data,
      message: errormessage,
    })
    .then((response) => {
      console.log("错误已报告：", response);
    })
    .catch((error) => {
      console.error("报告错误时出错：", error);
    });
}
// 暴露出去
export { axiosInstance1, request };
